import { atom } from "jotai";

export const showPopupAtom = atom(false);
export const popupCookieExistsAtom = atom(false);
export const blockPopupAtom = atom(false);

export const displayChiliPiperAtom = atom(false);
